import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_ICF, API_URL } from '../common';

@Injectable({
    providedIn: 'root',
})
export class IcfService {
    private apiUrlRoot = `${API_ICF}/root`;
    private apiUrlChapter = `${API_ICF}/chapter`;
    private apiUrlBlock = `${API_ICF}/block`;
    private apiUrlCategory = `${API_ICF}/category`;
    private apiSearchICF = `${API_ICF}/search`;

    constructor(private http: HttpClient) {
      
    }
    
    getRoot(lang: string): Observable<any[]> {
        return this.http.get<any[]>(`${this.apiUrlRoot}/?lang=${lang}`);
    }

    searchICF(q: any | undefined, lang: string) {
        if (!q || q === '*') {
            q = '';
        } else {
            q = q.toLowerCase();
        }
        return this.http.get<any>(`${this.apiSearchICF}/${q.trim()}?lang=${lang}&html=true`);
    }

    getListTreeOfSearch(model: string, id: number, lang: string | null) {
        return this.http.get<any>(`${this.apiSearchICF}tree/${model}?id=${id}&lang=${lang}`);
    }

    getListTreeOfSearch_ICF(model: string, id: number, lang: string | null) {
        return this.http.get<any>(`${this.apiSearchICF}/${model}?id=${id}&lang=${lang}`);
    }

    getChapter(lang: string | null): Observable<any[]> {
        return this.http.get<any[]>(`${this.apiUrlChapter}/?lang=${lang}`);
    }
    getBlock(lang: string | null): Observable<any[]> {
        return this.http.get<any[]>(`${this.apiUrlBlock}/?lang=${lang}`);
    }
    getCategory(lang: string | null): Observable<any[]> {
        return this.http.get<any[]>(`${this.apiUrlCategory}/?lang=${lang}`);
    }

    getChildrenOfModel(lang: string | null, id: string, model: string) {
        return this.http.get<any[]>(
            `${API_ICF}/tree/${model.toLowerCase()}?id=${id}&lang=${lang ? lang : 'dual'}`
        );
    }

    getChildrendModel(lang: string | null, id: string, model: string) {
        return this.http.get<any[]>(`${API_ICF}/${model.toLowerCase()}/${id}/child/?lang=${lang}`);
    }

    getDetailOfModel(lang: string | null, id: string, model: string) {
        const headers = new HttpHeaders({
            'X-Client-IP':   localStorage.getItem('client_ip') || ''
        });
        return this.http.get<any[]>(
            `${API_ICF}/data/${model.toLowerCase()}?id=${id}&lang=${lang}`,
            { headers: headers }
        );
    }

    getDocumentList(category: string) {
        return this.http.get<any>(`${API_URL}/api/DOC/list/${category}`);
    }

    getDocumentDetails(id: number) {
        return this.http.get(`${API_URL}/api/DOC/data/${id}`);
    }

    // submit feedback

    submitFeedback(feedbackData: any) {
        let csrftoken: string = ''; // Assigning a default value
        if (document.cookie && document.cookie !== '') {
            const cookies = document.cookie.split(';');
            for (let i = 0; i < cookies.length; i++) {
                const cookie = cookies[i].trim();
                // Does this cookie string begin with the name we want?
                if (cookie.substring(0, 10) === 'csrftoken' + '=') {
                    csrftoken = decodeURIComponent(cookie.substring(10));
                    break;
                }
            }
        }
        const csrfToken = csrftoken;
        return this.http.post<any>(`${API_URL}/api/feedback/`, feedbackData, {
            headers: { 'X-CSRFToken': csrfToken, 'X-Client-IP':   localStorage.getItem('client_ip') || '' },
        });
    }

    getListFeedback() {
        return this.http.get<any>(`${API_URL}/api/feedback/ICF/`);
    }
}
